import React, { useState } from "react";
import "../style.scss";
import { Exercise } from "../../../models/Exercise";
import CalendarOneExercise from "./CalendarOneExercise";
import CalendarMultiExercise from "./CalendarMultiExercise";
import { SelectionState } from "./hooks/useCalendarModal";
import StepIndicator from "./shared/StepIndicator";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import EAButton from "../../shared/Buttons/EAButton";
import EAModal from "../../shared/Modal/EAModal";
import CalendarDayPicker from "../DayPicker";

interface CalendarMobileViewProps {
  selectedDate: Date;
  exerciseName: string;
  listaDat?: Date[];
  firstAvailableDate?: Date;
  soldOutDates?: Date[];
  exercise: Exercise[];
  alerts: string;
  selectionState: SelectionState;
  onDateSelect: (date: Date, name: string) => void;
  onTimeSelect?: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  refreshCapacityAfterAddTicket: () => void;
  showHoursToChoose: boolean;
}

const CalendarMobileView: React.FC<CalendarMobileViewProps> = ({
  selectedDate,
  exerciseName,
  listaDat = [],
  firstAvailableDate,
  soldOutDates = [],
  exercise,
  alerts,
  selectionState,
  onDateSelect,
  onTimeSelect,
  joinToExerciseByPass,
  refreshCapacityAfterAddTicket,
  showHoursToChoose,
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalClose = (boolean: boolean) => {
    setIsModalOpen(boolean);
  };

  const isDateSelected = selectionState >= SelectionState.DATE_SELECTED;

  return (
    <div className="calendar-modal">
      <div className="calendar-modal-steps">
        <StepIndicator number={1} label={t("wybierz_date")} />
      </div>

      <div className="box-mobile flex-between-center">
        <div className="box-text">
          {!isDateSelected ? (
            <b className="body-text-large">{t("wybierz_dzien")}</b>
          ) : (
            <>
              <b className="body-text-small">Wybrano</b>
              <b className="body-text-large primary-color">{format(selectedDate, "dd.MM.yyyy")}</b>
            </>
          )}
        </div>

        <EAButton
          title={!isDateSelected ? t("wybierz") : t("zmien")}
          onClick={() => setIsModalOpen(true)}
          variant={!isDateSelected ? "filled" : "outlined"}
        />
      </div>

      {exercise.length > 0 && isDateSelected && (
        <>
          {showHoursToChoose === false ? (
            <CalendarOneExercise
              alertCalendar={alerts}
              joinToExerciseByPass={joinToExerciseByPass}
              exercise={exercise[0]}
              refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
            />
          ) : (
            <CalendarMultiExercise
              alertCalendar={alerts}
              joinToExerciseByPass={joinToExerciseByPass}
              exercise={exercise}
              clicked={selectionState}
              refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
              onTimeSelect={onTimeSelect}
            />
          )}
        </>
      )}

      <EAModal isOpen={isModalOpen} onClose={() => handleModalClose(false)} hideButtons title={t("wybierz_date")}>
        <CalendarDayPicker
          getExercisesByDate={onDateSelect}
          selectedDate={selectedDate}
          exerciseName={exerciseName}
          handleCloseModal={handleModalClose}
          listaDat={listaDat}
          firstAvailableDate={firstAvailableDate}
          soldOutDates={soldOutDates}
        />
      </EAModal>
    </div>
  );
};

export default CalendarMobileView;
